import { useEffect } from "react";
import { setAuthenticatedUser, clearAuthenticatedUser, trackAppInsightsPageView } from "./AppInsights";
import { useAppSelector } from "../store/hooks";
import { useLocation } from "react-router";
const AppInsightsUserContext = () => {
  const userName = useAppSelector(
    (state) => state.patientProfileDetails.patientProfileInfo.name
  );
  
  const location = useLocation();
  useEffect(() => {
    if (userName) {
      trackAppInsightsPageView({
        path: location.pathname,
        username: userName,
      });
    }
    
  }, [location.pathname, userName]);

  useEffect(() => {
    if (userName) {
      setAuthenticatedUser(userName.toString());

      const handleUnload = () => {
        clearAuthenticatedUser(userName.toString());
      };

      window.addEventListener("beforeunload", handleUnload);

      return () => {
        window.removeEventListener("beforeunload", handleUnload);
        clearAuthenticatedUser(userName.toString());
      };
    }
  }, [userName]);

  return null;
};

export default AppInsightsUserContext;
